<app-choose-subscription-packs [redirect]="true" (onValidateDone)="closeDialog($event)"></app-choose-subscription-packs>
